import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { PGA_COM_HOST } from 'env'
import buildBenchmarkMetrics from './build-benchmark-metrics'
import { BUSINESS_BOTTLENECK_QUERY } from './query'

const useCoachBenchmarks = () => {
  const { data, loading, error } = useQuery(BUSINESS_BOTTLENECK_QUERY)
  const coach = data?.currentUser?.attributes
  const bottleneck = coach?.businessBottleneck ?? null
  const slug = coach?.coachProfile?.slug
  const metrics = useMemo(() => buildBenchmarkMetrics(bottleneck), [bottleneck])

  return {
    bottleneck,
    metrics,
    leadAutoReplyEnabled: Boolean(coach?.preferences?.leadAutoReplyEnabled),
    bookingUrl: coach?.bookingUrl ?? null,
    shareUrl: slug ? `${PGA_COM_HOST}/coach/${slug}` : null,
    cohortSize: bottleneck?.peers?.cohortSize ?? null,
    loading: loading && !data,
    error,
  }
}

export default useCoachBenchmarks
